<template>
  <div class="bodys">
    <div
      v-if="!moreMessgeForm && sendMessgeShow != 'look'"
      :style="{ height: screenHeight - 163 + 'px' }"
    >
      <div class="w_100 flex">
        <div class="w_65">
          <!-- 轮播 -->
          <el-carousel
            :interval="5000"
            arrow="always"
            class="bdRadios"
            height="315px"
          >
            <el-carousel-item v-for="item in pics" :key="item">
              <img :src="item" alt style="width: 100%; height: 315px" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- 消息栏 -->
        <div class="w_33 pl20pr30 maxHeight300">
          <div class="flex_between relative">
            <div class="coB6">消息栏</div>
            <div class="coB6 pointer" @click="moreMessge">更多 》</div>
          </div>
          <div class @mouseenter="Stop()" @mouseleave="Up()">
            <div v-if="messageList.length == 0" class="flex_align flex_jus_cen">
              <img src="./22.png" alt />
            </div>
            <div
              class="messageBar flex_between scrollContent pointer"
              :style="{ top }"
              v-for="(item, index) in messageList"
              :key="index"
              v-else
              @click="lookDetail(item)"
            >
              <div class="w80">{{ item.sendTime.substr(0, 10) }}</div>
              <div
                class="maxWidth200"
                :class="item.isRead == 1 ? 'co_c9' : 'co_333'"
              >
                {{ item.messageTitle }}
              </div>
              <el-tag :type="item.messageCode">{{ item.messageType }}</el-tag>
            </div>
          </div>
        </div>
      </div>
      <div
        class="w_100 flex mt2"
        :style="{ height: screenHeight - 486 + 'px' }"
      >
        <div class="w_65 flex">
          <!-- 待办事项 -->
          <div class="w_35 bdRadios pl20pr30 pt10">
            <div class="flex_between">
              <div class="coB6">待办事项</div>
              <div class="coB6 pointer" @click="goPersonalBusiness">
                更多 》
              </div>
            </div>
            <div
              class="flex_align flex_jus_cen pt10 pointer"
              v-if="TodoList.length == 0"
            >
              <img src="./11.png" alt />
            </div>
            <div
              class="flex_align pt10 pointer mt10"
              v-for="(item, index) in TodoList"
              :key="index"
              v-else
              @click="redirectionMenu(item, 'toAudit')"
            >
              <div class="coB6 w40">{{ item.createTime }}</div>
              <div class="co_92 ml20 ellipsis w160">
                {{ item.applicantName }}提交的{{
                  item.dicMap.businessType
                }}未处理
              </div>
            </div>
          </div>
          <!-- 预警中心 -->
          <div class="w_62 bdRadios pl20pr30 pt10">
            <div class="flex_between">
              <div class="coB6">预警提示</div>
            </div>
            <!-- <div class="flex_warp flex_between">
              <div class="warningBox">
                <div
                  class="flex_align pointer"
                  @click="toPosWarningCenter('posStoresEffectiveGoods')"
                >
                  <i class="el-icon-time timeIcon"></i>
                  <div class="co_red ml20">门店品种近效期</div>
                </div>
                <div class="flex_align mt20">
                  <div class="Numbers">
                    <countTo
                      :startVal="startVal"
                      :endVal="storeTotal.effectiveTimeProductTotalNumber"
                      :duration="3000"
                    ></countTo>
                  </div>
                  <div class="co_999">批号临近效期</div>
                </div>
              </div>
              <div class="warningBox">
                <div
                  class="flex_align pointer"
                  @click="toPosWarningCenter('posStoresLongTime')"
                >
                  <i class="el-icon-house WarehouseIcon"></i>
                  <div class="co_000 ml20">门店在库长时间商品</div>
                </div>
                <div class="flex_align mt20">
                  <div class="Numbers">
                    <countTo
                      :startVal="startVal"
                      :endVal="storeTotal.inStockTimeProductTotalNumber"
                      :duration="3000"
                    ></countTo>
                  </div>
                  <div class="co_999">个批次在库时间过长</div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <!-- 统计分析 -->
        <div class="w_33 pl20pr30 pt10">
          <div class="flex_between">
            <div class="coB6">统计分析</div>
            <div class="coB6 pointer">更多 》</div>
          </div>
          <div>
            <LineEcharts
              :id="ids"
              :width="LineEchartswidths"
              :height="LineEchartsheights"
            ></LineEcharts>
          </div>
        </div>
      </div>
    </div>
    <moreNew
      v-if="moreMessgeForm && sendMessgeShow != 'look'"
      @backshow="backshow"
    ></moreNew>
    <lookMessge
      v-if="sendMessgeShow == 'look'"
      @returnList="returnList"
      ref="lookMessge"
    ></lookMessge>
  </div>
</template>

<script>
import moreNew from "./new";
import countTo from "vue-count-to";
import LineEcharts from "../../components/ECharts/lineEcharts";
import lookMessge from "./lookMessge";
export default {
  name: "mainIndex",
  components: {
    LineEcharts,
    countTo,
    moreNew,
    lookMessge
  },
  data() {
    return {
      sendMessgeShow: "index",
      storeTotal: {},
      ids: "1",
      LineEchartswidths: "100%",
      LineEchartsheights: "400px",
      startVal: 0,
      endVal: 55,
      messageList: [],
      TodoList: [],
      top: 0,
      activeIndex: 0,
      intnum: undefined,
      screenHeight: document.documentElement.clientHeight, //屏幕高度
      moreMessgeForm: false,
      pics: [
        "http://file-micromall.xczhyf.cn/uploadeFile/jtgw/pc/images/banner.png"
        // "http://file-micromall.xczhyf.cn/uploadeFile/jtgw/pc/images/banner.png",
        // "http://file-micromall.xczhyf.cn/uploadeFile/jtgw/pc/images/banner.png",
      ],
      scrollUp: null
    };
  },

  destroyed() {
    window.onresize = null;
    clearTimeout(this.scrollUp);
  },
  methods: {
    // echart自适应
    selfAdaption() {
      let that = this;
      setTimeout(() => {
        window.onresize = function() {
          if (that.$refs.echarts) {
            that.$refs.echarts.chart.resize();
          }
        };
      }, 10);
    },
    moreMessge() {
      this.moreMessgeForm = true;
    },
    //获取消息列表
    getMessageList() {
      // let data = {};
      // this.request(
      //   this.Appconstance.REQUEST_TYPE.POST,
      //   this.adminApi.homerenovation.showList,
      //   data,
      //   false
      // ).then((res) => {
      //   this.messageList = res.rows.slice(0, 10);
      //   this.ScrollUp();
      // });
    },
    //获取待办事项列表
    getTodoList() {
      let data = {};
      // this.request(
      //   "Post",
      //   this.adminApi.basiFiles.waitApprovedList,
      //   data,
      //   false
      // ).then(res => {
      //   this.TodoList = res.rows.slice(0, 9);
      //   for (let i in this.TodoList) {
      //     if (this.TodoList[i].createTime != null) {
      //       this.TodoList[i].createTime = this.TodoList[i].createTime.substr(
      //         5,
      //         6
      //       );
      //     }
      //   }
      // });
    },
    lookDetail(item) {
      this.sendMessgeShow = "look";
      this.$nextTick(function() {
        this.$refs.lookMessge.getMessgeInfo(item);
      });
    },
    goPersonalBusiness() {
      this.$router.push("/personalAffairs");
    },
    /**
     *@method:redirectionMenu
     *@description:跳转菜单详情
     **/
    redirectionMenu(item, type) {
      let obj = item;
      obj.type = type;
      this.$router.push({
        name: obj.menuCode,
        params: obj
      });
      //   PURCHASE_PLAN(1, "requisitionManage", "audit", "请货申请单"),
      //   PURCHASE_BACK(2, "deliveryRefund", "audit", "配送退货申请单"),
      //   INSTALL_BUCKET(3, "installBucket", "audit", "装斗申请单"),
      //   CLEAR_BUCKET(4, "clearBucket", "audit", "清斗申请单"),
      //   PRODUCT_OPEN(5, "ScatteredRecords", "audit", "商品拆零申请单"),
      //   RETAIL_BACK(6, "RetreatManagement", "", "重点养护"),
      //   PURCHASE_REJECTION(7, "deliveryRejected", "audit", "配送拒收单"),
      //   RETAIL_RECIPE_APPLY(8, "PrescriptionManagement", "", "零售处方申请单"),
      //   QUALITY_REVIEW(9, "queryQualityRepBills", "audit", "重点养护");
    },
    ScrollUp() {
      if (this.messageList.length >= 7) {
        this.intnum = setInterval(() => {
          this.activeIndex += 1;
          this.top = -this.activeIndex * 40 + "px";
          this.scrollUp = setTimeout(() => {
            this.messageList.push(this.messageList[this.activeIndex]);
          }, 300);
        }, 2000);
      }
    },
    returnList() {
      this.sendMessgeShow = "list";
      this.moreMessgeForm = true;
    },
    //预警中心
    getWarningCenterNumber() {
      // let data = {};
      // this.request(
      //   this.Appconstance.REQUEST_TYPE.POST,
      //   this.adminApi.homerenovation.getWarningCenterNumber,
      //   data,
      //   false
      // ).then((res) => {
      //   this.storeTotal = res.mapInfo;
      // });
    },
    /**
     *@method:toPosWarningCenter
     *@description:跳转预警中心
     *@param:type:posStoresEffectiveGoods 门店品种近效期  posStoresLongTime 门店在库长时间商品
     **/
    toPosWarningCenter(type) {
      let code = `/${type}`;
      this.$router.history.push({
        path: code
      });
    },
    Stop() {
      clearInterval(this.intnum);
    },
    Up() {
      this.ScrollUp();
    },
    backshow() {
      this.moreMessgeForm = false;
    }
  },
  created() {},
  mounted() {
    this.getTodoList();
    this.getMessageList();
    this.getWarningCenterNumber();
    this.$eventHub.$on("getTodoAllList", val => {
      if (val) {
        this.getTodoList();
      }
    });
  }
};
</script>
<style lang="scss" scoped="scoped">
.mt10 {
  margin-top: 10px;
}
.co_000 {
  font-family: "Arial Negreta";
  font-weight: 700;
  font-size: 12px;
  color: #000000;
}
.co_6DB {
  font-family: "Arial Negreta";
  font-weight: 700;
  font-size: 12px;
  color: #1296db;
}
.w_100 {
  padding-top: 10px;
}
.co_999 {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  font-weight: 700;
  font-style: normal;
  font-size: 12px;
  color: #999999;
}
.Numbers {
  padding-left: 30px;
  padding-right: 30px;
  font-family: "Arial Negreta";
  font-weight: 700;
  font-style: normal;
  font-size: 28px;
  color: #5e5e5e;
}
.mt20 {
  margin-top: 20px;
}
.co_red {
  font-family: "Arial Negreta";
  font-weight: 700;
  font-size: 12px;
  color: red;
}
.WarehouseIcon {
  width: 20px;
  text-align: center;
  line-height: 20px;
  height: 20px;
  color: #fff;
  background: #000000;
  border-radius: 50%;
}
.QualificationsIcon {
  width: 20px;
  text-align: center;
  line-height: 20px;
  height: 20px;
  color: #fff;
  background: #1296db;
  border-radius: 50%;
}
.timeIcon {
  width: 20px;
  text-align: center;
  line-height: 20px;
  height: 20px;
  color: #fff;
  background: red;
  border-radius: 50%;
}
.warningBox {
  padding-left: 20px;
  padding-top: 10px;
  margin-top: 30px;
  width: 48%;
  height: 100px;
  border-radius: 10px;
  background-color: rgba(242, 242, 242, 1);
}
.flex_warp {
  display: flex;
  flex-wrap: wrap;
}
.w160 {
  width: 270px;
  font-family: "Microsoft YaHei";
  font-weight: 700;
}
.ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.w40 {
  width: 40px;
}
.ml20 {
  margin-left: 20px;
}
.co_92 {
  color: #929292;
  font-family: "Microsoft YaHei";
  font-weight: 700;
}
.pt10 {
  padding-top: 10px;
}
.w80 {
  min-width: 80px;
}
.relative {
  position: relative;
  z-index: 20;
  height: 40px;
  background: #fff;
  padding-top: 10px;
  box-sizing: border-box;
  // transition: top 0.5s;
}
.scrollContent {
  position: relative;
  transition: top 0.5s;
  // height:260px;
  // overflow: hidden;
}
.maxHeight300 {
  max-height: 315px;
  overflow: hidden;
}
.maxWidth200 {
  padding-left: 10px;
  padding-right: 10px;
  max-width: 320px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.messageBar {
  font-family: "Arial Normal", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  color: #333333;
  font-size: 13px;
  margin-bottom: 10px;
  height: 30px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.co_c9 {
  color: #c9c9c9;
}
.co_333 {
  color: #333333;
}
.w_35 {
  width: 35%;
  background: #fff;
}
.w_62 {
  width: 62%;
  margin-left: 3%;
  background: #fff;
}
.mt2 {
  margin-top: 20px;
  margin-bottom: 20px;
}
.pointer {
  cursor: pointer;
}
.coB6 {
  color: #b6b6b6;
}
.pl20pr30 {
  // padding-top: 10px;
  padding-left: 20px;
  padding-right: 30px;
}
.bdRadios {
  border-radius: 8px;
}
.w_65 {
  width: 65%;
}
.w_33 {
  width: 33%;
  margin-left: 2%;
  background: #fff;
  border-radius: 8px;
}
.bodys {
  background-color: rgba(243, 245, 247, 1);
  padding: 0 30px;
  height: 100%;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 315px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.pointer {
  cursor: pointer;
}
// $top: top;
// $bottom: bottom;
// $left: left;
// $right: right;
// $leftright: ($left, $right);
// $pinkk: #eec2d3;
// $bluee: #409eff;
// $yelloww: #f4d884;
// $grennn: #89dda0;
// $purplee: #78a2ea;
// $lightBluee: #b8d6ff;

// $list: bluee pinkk yelloww grennn purplee lightBluee;
// $list1: $bluee $pinkk $yelloww $grennn $purplee $lightBluee;
// %shadow {
//   background: #fff;
//   -webkit-box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.2);
//   box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.2);
//   border-color: rgba(0, 0, 0, 0.2);
//   .title {
//     font-size: 14px;
//     padding: 10px;
//     i {
//       margin-#{$right}: 5px;
//     }
//   }
// }

// @mixin flex($direction: row, $content: space-between) {
//   display: flex;
//   flex-direction: $direction;
//   justify-content: $content;
// }
// .card {
//   color: #666;
//   @extend %shadow;

//   ul {
//     @include flex;
//     li {
//       flex: 1;
//       a {
//         color: #666666;
//         align-items: center;
//         padding-#{$top}: 20px;
//         padding-#{$bottom}: 20px;
//         @include flex(column);
//         span {
//           height: 44px;
//         }
//         .num {
//           line-height: 44px;
//           font-size: 42px;
//           color: $bluee;
//           margin: 0px;
//         }
//       }
//       .kjfs-bluee {
//         color: $bluee;
//       }
//       .kjfs-pinkk {
//         color: $pinkk;
//       }
//       .kjfs-yelloww {
//         color: $yelloww;
//       }
//       .kjfs-grennn {
//         color: $grennn;
//       }
//       .kjfs-purplee {
//         color: $purplee;
//       }
//       .kjfs-lightBluee {
//         color: $lightBluee;
//       }
//       &:hover {
//         .kjfs-bluee {
//           color: #ffffff;
//           background: $bluee;
//         }
//         .kjfs-pinkk {
//           color: #ffffff;
//           background: $pinkk;
//         }
//         .kjfs-yelloww {
//           color: #ffffff;
//           background: $yelloww;
//         }
//         .kjfs-grennn {
//           color: #ffffff;
//           background: $grennn;
//         }
//         .kjfs-purplee {
//           color: #ffffff;
//           background: $purplee;
//         }
//         .kjfs-lightBluee {
//           color: #ffffff;
//           background: $lightBluee;
//         }
//       }
//     }
//   }
//   .table {
//     padding: 21px;
//     p {
//       height: 52px;
//       line-height: 52px;
//       border: 1px solid #cccccc;
//       overflow: hidden;
//       border-#{$top}: none;
//       @include flex(null, start);
//       &:first-child {
//         border-#{$top}: 1px solid #cccccc;
//       }
//       span {
//       }
//       .tit {
//         width: 90px;
//         min-width: 90px;
//         height: 100%;
//         text-align: center;
//         border-#{$right}: 1px solid #cccccc;
//         margin-#{$right}: 18px;
//       }
//       span.gitbox {
//         flex: 1;
//         height: 100%;
//         overflow: hidden;
//         @include flex(row, start);
//         a {
//           &:first-child {
//             margin-#{$right}: 30px;
//           }
//         }
//       }
//     }
//   }
// }
// #lineEcharts {
//   margin-#{$top}: 30px;
//   padding-#{$top}: 30px;
//   @extend %shadow;
// }
// #maintable {
//   margin-#{$top}: 30px;
//   padding-#{$top}: 10px;
//   @extend %shadow;
// }
</style>



// WEBPACK FOOTER //
// src/views/index/mainIndex.vue